export default "__VITE_ASSET__baae6df5__"